"use client";

import LoadingHero from "@/components/index/fragments/LoadingHero";
import Profile from "@/components/index/fragments/Profile";
import { PageTourButton } from "@/components/tutorial/PageTourButton";
import { useLanguage } from "@/context/LanguageContext";

type AppPageIntroSlotProps = {
  hiddenTargets?: string[];
  hasPortfolioEstate?: boolean;
  hasWatchdog?: boolean;
  hasWatchdogResults?: boolean;
  isProfileLoading?: boolean;
  showProfile?: boolean;
};

export function AppPageIntroSlot({
  hiddenTargets,
  hasPortfolioEstate,
  hasWatchdog,
  hasWatchdogResults,
  isProfileLoading = false,
  showProfile = false,
}: AppPageIntroSlotProps) {
  const { language } = useLanguage();
  const profile = isProfileLoading ? (
    <div className="app-section-card w-full !p-6">
      <LoadingHero />
    </div>
  ) : (
    <Profile compact />
  );

  return (
    <div className="app-page-intro-slot" aria-label="Page actions">
      <aside
        data-tour={showProfile ? "dashboard-profile" : undefined}
        className={`app-page-intro-card ${
          showProfile ? "" : "invisible pointer-events-none"
        }`}
        aria-hidden={!showProfile}
        aria-label={language === "cs" ? "Přehled účtu" : "Account overview"}
      >
        {profile}
      </aside>

      <div className="app-page-guide-row">
        <PageTourButton
          className="app-page-guide-button"
          hiddenTargets={hiddenTargets}
          hasPortfolioEstate={hasPortfolioEstate}
          hasWatchdog={hasWatchdog}
          hasWatchdogResults={hasWatchdogResults}
        />
      </div>
    </div>
  );
}
